<template>
  <div class="SaleOrders">
    <div class="page-title">{{ title }}</div>

    <div class="flex">
      <div class="lt-area flex-auto">
        <el-input
          class="input-with-select"
          size="mini"
          :placeholder="searchPlaceholder"
          v-model="searchWord"
          clearable
          style="width: 300px;"
          @keydown.enter.native="handleClickFilter"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleClickFilter"
          />
        </el-input>

        <div class="right-search-head inline" style="margin-left: 10px">
          <div class="inline">
            <APeriodSelector
              ref="period"
              :value="search_period"
              hide-select
              @change="handleChangePeriod"
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
              >검색(F5)</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div>
      <ATable
        ref="table_contract"
        class="no-pointer"
        max-height="700px"
        v-loading="loading_contract"
        :data="filterDataContract"
        :row-class-name="soldTableRowClassName"
        border
        hide-button-insert
        hide-pagination
        @selection-change="contractSelectionChange"
      >
        <div slot="search" class="list-title">수주 리스트</div>
        <el-table-column
          type="selection"
          label="선택"
          align="center"
          :width="$width.selection"
        />
        <el-table-column
          type="index"
          label="No"
          :index="handleIndexContract"
          :width="$width.index"
        />
        <el-table-column prop="code" label="수주번호" width="100" />
        <el-table-column
          prop="contract_date"
          label="수주일"
          :width="$width.date"
        />
        <el-table-column
          prop="delivery_date"
          label="납기일"
          :width="$width.date"
        />
        <el-table-column prop="customer_name" label="거래처" width="200" />
        <el-table-column prop="product_name" label="품목" />
        <el-table-column
          prop="price"
          class-name="cell-number"
          label="금액"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <el-button
            type="primary"
            :disabled="contractSelection.length < 1 || !has_grant_write"
            @click="handleClickSaveSale"
            >매출 등록</el-button
          >
        </div>
      </ATable>
    </div>
  </div>
</template>
<script>
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";

export default {
  name: "SaleOrders",
  mixins: [form_container, authority_level],
  data() {
    return {
      title: this.$t("title.sale_orders"),
      search_period: { value: "0d" },
      period: {},
      searchPlaceholder: "수주번호, 거래처, 납기일, 품목",
      search_field: [
        "code",
        "contract_code",
        "customer_name",
        "delivery_date",
        "product_name",
      ],
      searchWord: null,
      fixedSearchWord: "",
      loading_contract: false,
      items_contract: [],
      contractSelection: [],
      items_sale: [],
    };
  },
  computed: {
    /* 수주 */
    filterDataContract: function() {
      return this.util.filterMultiFields(
        this.items_contract,
        this.search_field,
        this.fixedSearchWord
      );
    },
    has_grant_write() {
      return this.isWriteLevel("sale_orders");
    },
  },
  mounted() {
    this.$nextTick(() => this.handleClickSearch());
  },
  methods: {
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.currentPageContract = 1;
      this.currentPageSale = 1;
      this.loadData();
    },
    handleClickFilter() {
      this.currentPageContract = 1;
      this.currentPageSale = 1;
      this.fixedSearchWord = this.searchWord;
    },
    loadSaleContract() {
      this.loading_contract = true;
      this.api.listContractNonSale(this.period).then((res) => {
        this.loading_contract = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items_contract = res.data;
        this.items_contract.forEach((item) => {
          item.product_name = this.productNaming(item);
        });
      });
    },
    loadData() {
      this.loadSaleContract();
    },
    compareContract() {
      return function(a, b) {
        if (a.code < b.code) {
          return -1;
        } else if (a.code === b.code) {
          return a.seq - b.seq;
        } else {
          return 1;
        }
      };
    },
    soldTableRowClassName({ row /*, rowIndex*/ }) {
      if (row.production_amount > 0) return "sold-row";
      return "";
    },
    contractSelectionChange(selection) {
      this.contractSelection = selection;
    },
    handleCurrentChangeContract(value) {
      this.currentPageContract = value;
    },
    handleIndexContract(index) {
      return this.$refs.table_contract.indexResolver(index);
    },
    handleClickSaveSale() {
      if (this.contractSelection.length < 1) {
        this.util.notify_warning(
          this,
          this.title,
          this.$t("message.no_selection")
        );
        return;
      }
      this.loading_contract = true;
      let params = this.contractSelection.map((item) => item.id);
      this.api.registerSale(params).then((res) => {
        this.loading_contract = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.loadData();
      });
    },
    productNaming(item) {
      if (item.details.length < 1) {
        return "";
      } else if (item.details.length > 1) {
        return (
          item.details[0].product_name +
          " 외 " +
          (item.details.length - 1) +
          "건"
        );
      } else {
        return item.details[0].product_name;
      }
    },
  },
};
</script>
